<template>
  <!-- 抽离aside混合的html公用样式 -->

  <div>

    <ul class="sidebar-card">
      <li class="title">
        <i class="el-icon-info"></i>
        聯絡我們
      </li>
    </ul>
    <!-- 联络我们 -->
    <ul class="sidebar-card" v-if="contactus">
      <li :class="{ 'text-bold': item.important }" v-for="(item, index) in contactus" :key="index">{{ item.text | langueageFormat }}</li>
    </ul>

    <ul class="sidebar-card">
      <li class="title" style="margin-bottom: 0;">
        <i class="el-icon-info"></i>
        {{ $t('asideDescription[2].title') }}
      </li>
      <li style="padding: 0 10px;">
			<iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fmanybofans&tabs&width=200&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=431284020291966" width="200" height="130" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
	</li>
    </ul>
  </div>
</template>
<script>
export default {
  created() {
    this.$axios({
      url: '/Common/getWebSidebarCrazy',
      method: 'GET',
    }).then(({contact_us}) => {
      this.contactus = contact_us || null
    })
  },
  methods: {
  },
  data() {
    return {
      contactus: null
    }
  },
}
</script>
<style lang="stylus" scoped>
.sidebar-card {
  padding: 0;
  margin-bottom: 20px;

  li {
    list-style: none;
    margin: 0;
    padding: 5px 20px;

    &.title {
      padding: 0 20px;
      color: #73AE18;
      font-weight: bold;
      border-bottom: solid 2px #73AE18;
      margin: 0 10px 10px 10px;
      padding: 5px;
    }

    i {
      margin-right: 0px;
      color: #73AE18;
    }
  }
}
</style>
